<template>
  <div class="footer">
    <div class="footer-btn">
      <div
        :class="{
          container: true,
          tootip:
            !user?.role.permissions.pharmacy.update &&
            $route.name === 'EditPharmacy'
        }"
      >
        <Button
          :variant="getVariant()"
          :title="$t('save')"
          :disabled="disabledButton()"
          @click="$emit('submitForm')"
        />
        <span
          v-if="
            !user?.role.permissions.pharmacy.update &&
            $route.name === 'EditPharmacy'
          "
          class="tooltiptext"
        >
          {{ $t('enoughPermissions') }}
        </span>
      </div>
      <!-- <Button
        v-if="$route.name === 'EditPharmacy'"
        :variant="disabledMakeServiceRequest ? 'disabledLong' : 'wideBordered'"
        :title="
          disabledMakeServiceRequest
            ? $t('seriviceRequested')
            : $t('makeServiceRequest')
        "
        @click="$emit('openModalServiceRequest')"
      /> -->
      <a
        class="link-helpdesk"
        href="https://apoteketab.sharepoint.com/sites/Helpdesk/SitePages/Kontaktaoss.aspx"
        target="_blank"
      >
        <Button
          v-if="$route.name === 'EditPharmacy'"
          variant="wideBordered"
          :title="$t('referToHelpdesk')"
        />
      </a>
      <div
        :class="{
          container: true,
          tootip:
            !user?.role.permissions.pharmacy.update &&
            $route.name === 'EditPharmacy'
        }"
      >
        <Button
          :variant="getVariantButtonCleanFields()"
          :title="$t('cleanFields')"
          :disabled="disabledButton()"
          @click="$emit('cleanForm')"
        />
        <span
          v-if="
            !user?.role.permissions.pharmacy.update &&
            $route.name === 'EditPharmacy'
          "
          class="tooltiptext"
        >
          {{ $t('enoughPermissions') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

@Options({
  name: 'Footer',
  props: ['disabledMakeServiceRequest'],
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    getVariant() {
      if (
        !this.user?.role.permissions.pharmacy.update &&
        this.$route.name === 'EditPharmacy'
      ) {
        return 'disabled';
      } else {
        return 'filled';
      }
    },
    disabledButton() {
      if (
        !this.user?.role.permissions.pharmacy.update &&
        this.$route.name === 'EditPharmacy'
      ) {
        return true;
      } else {
        return false;
      }
    },
    getVariantButtonCleanFields() {
      if (this.$route.name === 'EditPharmacy') {
        if (!this.user?.role.permissions.pharmacy.update) {
          return 'disabledNotBordered';
        } else {
          return 'notBordered';
        }
      }

      if (
        this.$route.name === 'InfoUser' &&
        this.user?.role.permissions.user.update
      ) {
        return 'notBordered';
      }
    }
  }
})
export default class FooterComponent extends Vue {}
</script>

<style lang="scss" scoped>
.footer {
  height: 73px;
  width: calc(100% - 207px);
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  border-top: 1px solid $ligher-grey;
  background: $white;
  z-index: 2;
  .footer-btn {
    display: flex;
    align-items: center;
    .container {
      margin-left: 24px;
    }
    .tootip {
      position: relative;
      .tooltiptext {
        position: absolute;
        top: -30%;
        left: 50%;
        transform: translate(-50%, -100%);
        visibility: hidden;
        width: 150px;
        font-size: $elevenSize;
        line-height: $elevenSize;
        background: $label;
        color: $white;
        text-align: center;
        border-radius: 6px;
        padding: 5px;
        z-index: 1;
        opacity: 0;
        transition: opacity 0.3s;
        &::after {
          content: '';
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: $label transparent transparent transparent;
        }
      }

      &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
    }
    .wideBordered,
    .disabledLong {
      margin-left: 24px;
    }
  }
}

.fooderDisabled {
  display: none;
}
</style>
